import { useT } from "@/lib/i18n";

export default function LanguageToggle({ variant = "light" }) {
    const { lang, setLang } = useT();
    const dark = variant === "dark";
    const base = dark
        ? "border-white/25 bg-white/10 text-white"
        : "border-black/10 bg-white text-ink-primary";

    return (
        <div
            data-testid="language-toggle"
            className={`inline-flex items-center rounded-full border ${base} p-1`}
        >
            {["en", "tr", "ro"].map((code) => (
                <button
                    key={code}
                    type="button"
                    data-testid={`lang-${code}`}
                    onClick={() => setLang(code)}
                    className={`px-3 py-1 text-[11px] uppercase tracking-[0.18em] font-semibold rounded-full transition-colors duration-200 ${
                        lang === code
                            ? dark
                                ? "bg-white text-brand-blue-dark"
                                : "bg-brand-green text-white"
                            : "hover:opacity-80"
                    }`}
                >
                    {code === "en" ? "EN" : code === "tr" ? "TR" : "RO"}
                </button>
            ))}
        </div>
    );
}
